export default __webpack_public_path__ + "static/media/dashboard.a5633fe5.svg";